<template>
  <div class="row myrow content-mb-42" v-if="$parent.$parent.rerender">
    <div
      class="col-xs-12 mycol content-mb-14"
      v-bind:class="{
        'has-error': $parent.$parent.checkErrorField(
          'PROJECTS',
          'LOGIC',
          'UF_CONG_NATIONAL_PROJECT_ID'
        )
      }"
    >
      <select
        v-model="$parent.project.UF_CONG_NATIONAL_PROJECT_ID"
        class="sel-dropdown i-main-style i-wid-29"
        v-on:change="changeVidNational()"
        :disabled="$parent.$parent.projectDisabled"
      >
        <option value=""></option>
        <option
          v-for="item in $parent.directory
            .sp_confirmation_part_national_project"
          v-bind:value="item.ID"
          v-bind:key="item.ID"
          v-text="item.NAME"
        ></option>
      </select>
      <div class="error-text">
        {{
          $parent.$parent.checkErrorText(
            "PROJECTS",
            "LOGIC",
            "UF_CONG_NATIONAL_PROJECT_ID"
          )
        }}
      </div>
    </div>

    <div
      class="col-xs-12 mycol content-mb-14"
      v-bind:class="{
        'has-error': $parent.$parent.checkErrorField(
          'PROJECTS',
          'LOGIC',
          'UF_NATIONAL_DOCUMENT'
        )
      }"
      v-if="$parent.project.UF_CONG_NATIONAL_PROJECT_ID > 0"
    >
      <p class="content-s-2-label">
        <label
          >Реквизиты документа, подтверждающего участие в Национальном проекте
          "Производительность труда":</label
        >
      </p>
      <textarea
        v-on:keyup="
          $parent.$parent.removeError(
            'PROJECTS',
            'LOGIC',
            'UF_NATIONAL_DOCUMENT'
          )
        "
        class="i-main-style t-dop-style i-wid-50"
        style="height:114px;"
        v-model="$parent.project.UF_NATIONAL_DOCUMENT"
        :disabled="$parent.$parent.projectDisabled"
        placeholder=""
      ></textarea>
      <div class="error-text">
        {{
          $parent.$parent.checkErrorText(
            "PROJECTS",
            "LOGIC",
            "UF_NATIONAL_DOCUMENT"
          )
        }}
      </div>
    </div>
  </div>
</template>

<script>
export default {
  name: "PromProducts",
  computed: {},
  methods: {
    changeVidNational() {
      this.$parent.$parent.removeError(
        "PROJECTS",
        "LOGIC",
        "UF_CONG_NATIONAL_PROJECT_ID"
      );
    }
  }
};
</script>

<style scoped></style>
